import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Customers from '../customers/customers';
import { getOwnerCustomers, fetchOwnerLetters } from '../customers/actions';

class shopUserCustomersWrapper extends Component {
  fetchCustomers = (letter, page) => this.props.fetchCustomers(this.props.shop, 'shop', letter, page);
  fetchLetters = () => this.props.fetchLetters(this.props.shop, 'shop');

  render() {
    return (
      <Customers
        fetchCustomers={this.fetchCustomers}
        fetchLetters={this.fetchLetters}
        link="/customers/add"
      />
    );
  }
}

shopUserCustomersWrapper.propTypes = {
  fetchCustomers: PropTypes.func.isRequired,
  fetchLetters: PropTypes.func.isRequired,
  shop: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  shop: state.auth.shop,
});

const mapDispatchToProps = {
  fetchCustomers: getOwnerCustomers,
  fetchLetters: fetchOwnerLetters,
};

export default connect(mapStateToProps, mapDispatchToProps)(shopUserCustomersWrapper);
